/**
 * The form brings down to the client the currently submitted data,
 * so that field visibility can be updated even if the
 * question their visibilty depends on was answered in a previous slide
 * @module embed/submission_data
 */

const SELECTOR = '.js-submission-data';

let submission = {};

/**
 * @param {HTMLElement} el The element into which the data is serialized as JSON
 */
export default function setupSubmissionData(el) {
  const dataEl = el.querySelector(SELECTOR);
  submission = parseSubmissionData(dataEl);
}

/**
 * Access a specific piece of information from the hash
 * @param {String} key The key for the data you want
 */
export function getSubmissionData(key) {
  return (submission.data || {})[key];
}

function parseSubmissionData(el) {
  if (!el) return {};

  const data = el.textContent;
  if (!data) return {};

  return JSON.parse(data);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/submission_data.js